import deviceSettingsEventType from './device-settings-event-type';
import shipmentEventType from './shipment-event-type';
import warehouseEventType from './warehouse-event-type';
import projectEventType from './project-event-type';

export default Object.freeze({
  EDIT_SETTINGS: deviceSettingsEventType.EDIT_SETTINGS,
  ADD_DEVICE_TO_APPLICATION: warehouseEventType.ADD_DEVICE,
  ADD_DEVICE_TO_SHIPMENT: shipmentEventType.ADD_DEVICE,
  ADD_DEVICE_TO_PROJECT: projectEventType.ADD_DEVICE,
  REMOVE_DEVICE_FROM_APPLICATION: warehouseEventType.REMOVE_DEVICE,
  REMOVE_DEVICE_FROM_SHIPMENT: shipmentEventType.REMOVE_DEVICE,
  REMOVE_DEVICE_FROM_PROJECT: projectEventType.DELETE_DEVICE
});
